export default __webpack_public_path__ + "8f89cbc7a6dcca9cf7ae952573225f01.png";